import { LeftOutlined } from "@ant-design/icons";
import { Collapse } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getCourseModulesDetailsData,
  getCourseraContentsDetails,
} from "../../slices/courseraSlice";
import { LoadingOutlined } from "@ant-design/icons";
import CourseDetails from "./CourseDetails";
import GradientButton from "../Button/GradientButton";

const SpecificCourse = () => {
  const [selectedWeek, setSelectedWeek] = useState("Week 1");
  const [selectedMenu, setSelectedMenu] = useState("Course Material");
  const [courseDetailsData, setCourseDetailsData] = useState();
  const courseData = useSelector((state) => state.coursera.courseData);
  const courseModuleData = useSelector(
    (state) => state.coursera.courseModulesDetailsData
  );
  const courseDataDetails = useSelector(
    (state) => state.coursera.courseDetailsData
  );

  console.log("🚀 ~ SpecificCourse ~ courseDataDetails:", courseDataDetails);
  const courseModuleSelectedData = courseModuleData?.filter(
    (id) => selectedWeek === id.id
  )[0];
  const selectedCourseData = courseDataDetails?.filter(
    (id) => selectedWeek === id.id
  )[0];

  const dispatch = useDispatch();
  const { id } = useParams();
  console.log("🚀 ~ CourseDetails ~ id:", id.includes("Specialization"));

  const moduleId = id.split("~")[1];
  const data = courseData?.elements?.filter((data) => data.id === id)[0];

  const dataId = data?.extraMetadata?.definition?.courseIds;
  console.log("🚀 ~ SpecificCourse ~ dataId:", dataId);
  const navigate = useNavigate();
  const onChange = (key) => {};
  const location = useLocation();
  const contentUrl = location?.state?.data?.programs?.[0]?.contentUrl ?? "";
  const conditionalData = id?.includes("Course")
    ? courseModuleData
    : courseDataDetails;

  useEffect(() => {
    if (id?.includes("Course")) {
      dispatch(getCourseModulesDetailsData(moduleId)).then((res) => {
        if (res) {
          setCourseDetailsData(res?.payload?.data?.elements[0]?.modules);
        }
      });
    } else {
      dispatch(getCourseraContentsDetails(dataId)).then((res) => {
        if (res) {
          setCourseDetailsData(res?.payload);
        }
      });
    }
  }, [moduleId, dataId]);

  return (
    <>
      {id.includes("Specialization") ? (
        <div className="bg-pureWhite rounded-2xl p-4 courses_Style ">
          <div
            className="w-fit  flex items-center gap-x-2 cursor-pointer"
            onClick={() => navigate(-1)}
          >
            <LeftOutlined style={{ color: "#8F8F8F", fontSize: 18 }} />
            <p className="text-[#8F8F8F] text-sm">Back to courses</p>
          </div>
          <div className="mt-7 flex justify-between items-center">
            <div className="flex gap-x-5 w-[70%]">
              <div className="">
                <img
                  src={data?.extraMetadata?.definition?.promoPhoto}
                  alt="Course Main Image"
                  className="w-[200px] h-[200px] rounded-lg"
                />
              </div>
              <div className="flex flex-col  justify-center">
                <p className="">{data?.partners[0]?.name}</p>
                <p className="text-[36px] font-semibold font-bizmo">
                  {data?.name}
                </p>
              </div>
            </div>
            <div className="flex flex-col justify-center">
              <GradientButton>
                <Link target="_" to={contentUrl}>
                  Enroll Course
                </Link>
              </GradientButton>
              {/* <p className="text-right text-[10px] text-[#8F8F8F] mt-5">
            Start date: September 13, 2023 PDT
          </p>
          <p className="text-right text-[10px] text-[#8F8F8F] mt-1">
            Estimated end date: October 29, 2023 PDT
          </p> */}
            </div>
          </div>
          <div>
            {courseDataDetails?.length ? (
              courseDataDetails?.map((lesson, i) => {
                return (
                  <Collapse
                    key={i}
                    defaultActiveKey={["1"]}
                    expandIconPosition="end"
                    bordered={false}
                    className="mt-5"
                  >
                    <Collapse.Panel
                      header={
                        <p className="font-semibold text-lg">{`Course ${
                          i + 1
                        }: ${lesson?.name}`}</p>
                      }
                    >
                      <div className="space-y-3">
                        <div className="flex gap-2">
                          <h1 className="font-semibold">Name:</h1>
                          <p>{lesson?.name}</p>
                        </div>
                        <div className="flex gap-2">
                          <h1 className="font-semibold">Language:</h1>
                          <p>{lesson?.languageCode}</p>
                        </div>
                        <div className="flex gap-2">
                          <h1 className="font-semibold">Live:</h1>
                          <a
                            target="_"
                            className="text-secondary5"
                            href={lesson?.programs[0]?.contentUrl}
                          >
                            {lesson?.name}
                          </a>
                        </div>
                      </div>
                      <div className="flex flex-wrap overflow-auto mt-5">
                        {lesson?.instructors?.map((items, i) => {
                          return (
                            <div
                              key={i}
                              className="w-[50%] flex flex-col items-center text-center gap-2 shadow-shadowOne p-3"
                            >
                              <img
                                className="rounded-full w-20 h-w-20"
                                src={items?.photoUrl}
                                alt={items?.title}
                              />
                              <h1 className="font-semibold">{items?.name}</h1>
                              {/* <p>{items.department}</p> */}
                              <p className="text-sm">{items?.title}</p>
                            </div>
                          );
                        })}
                      </div>
                    </Collapse.Panel>
                  </Collapse>
                );
              })
            ) : (
              <div className="flex justify-center items-center m-10">
                <LoadingOutlined style={{ fontSize: 30, color: "orange" }} />
              </div>
            )}
          </div>
        </div>
      ) : (
        <CourseDetails contentUrl={contentUrl} />
      )}
    </>
  );
};

export default SpecificCourse;
